<div class="table-sport__subhead d-flex align-items-start bg-light">
  @if (golfTournament.country_iso) {
    <img
      src="/img/flags/4x3/{{ golfTournament.country_iso | lowercase }}.svg"
      alt=""
      width="20"
      class="mr-2 mt-05"
      />
  }
  @if (!golfTournament.country_iso) {
    <img src="img/sports/golf.png" alt="" width="20" class="mr-2 mt-05" />
  }
  <div class="table-sport__subhead__text mb-0 text-wrap">
    @if (golfTournament.playoff) {
      PLAY OFF -
    }
    {{ golfTournament.name }}
    @if (golfTournament.country_iso3) {
      ({{ golfTournament.country_iso3 }})
      } -
      {{ golfTournament.start_date | livDate : 'dateShort2' }} - {{ golfTournament.end_date | livDate : 'date' }}
      @if (golfTournament.status) {
        -
        <strong class="text-emph2">{{ 'web.status-' + golfTournament.status | translate }}</strong>
      }
      <div class="text-muted mt-1">
        @if (golfTournament.purse) {
          {{ 'web.prize_money' | translate }}:
          <strong>{{ golfTournament.purse | localeCurrency : golfTournament.currency }}</strong>
        }
        @if (golfTournament.winning_share) {
          {{ 'web.winning_share' | translate }}:
          <strong>{{ golfTournament.winning_share | localeCurrency : golfTournament.currency }}</strong>
        }
        @if (golfTournament.defending_champ_participant) {
          &nbsp;&nbsp; {{ 'web.defending_champ' | translate }}:
          <a
                    [routerLink]="[
                        '/page/golf/participant/' +
                            sportName +
                            '-' +
                            sportId +
                            '/' +
                            golfTournament.defending_champ_participant?.id
                    ]"
            >
            {{ golfTournament.defending_champ_participant?.name }}
          </a>
        }
        @if (golfTournament.venue?.courses?.[0]?.par) {
          &nbsp;&nbsp; PAR: <strong>{{ golfTournament.venue.courses[0]?.par }}</strong>
        }
        @if (golfTournament.points) {
          &nbsp;&nbsp; {{ 'web.golf_points' | translate }}: <strong>{{ golfTournament.points }}</strong>
        }
      </div>
    </div>
    @if (sportId && sportName && showDetailBtn) {
      <a
        [routerLink]="['/page/golf/tournament', sportName + '-' + sportId, golfTournament.id]"
        class="ml-auto small text-reset app-custom-link"
        >
        {{ 'web.event-detail' | translate }}
      </a>
    }
  </div>
  @if (golfTournament.participants && golfTournament.participants.length !== 0) {
    <div>
      <div class="w-100 mt-3 mb-5">
        @if (golfTournament.participants && golfTournament.participants.length > 0) {
          <app-golf-table
            [data]="golfTournament"
            [sportName]="sportName"
            [sportId]="sportId"
          ></app-golf-table>
        }
        <!--        <app-stage-table *ngIf="golfTournament.participants[2] && golfTournament.participants[2].length > 0"-->
        <!--                         [participants]="golfTournament.participants[2]"-->
        <!--                         [valueTypes]="golfTournament.valueTypes.teams"-->
        <!--                         [stage]="stage"-->
        <!--                         [sportName]="sportName"-->
        <!--                         [sportId]="sportId"-->
      <!--        ></app-stage-table>-->
    </div>
  </div>
}
